import { QueryClient } from '@tanstack/react-query';

/**
 * Shared QueryClient instance for use throughout the application.
 * This is exported so it can be used both in React components (via Provider)
 * and in non-React code (like appRegistry.ts) via queryClient.fetchQuery().
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 50, // 50ms - balance between freshness and preventing unnecessary renders
    },
  },
});
